module.exports = __webpack_public_path__ + "static/media/wave-blue.3af1e4c5.png";